/* eslint-disable class-methods-use-this */
// eslint-disable-next-line import/no-extraneous-dependencies
import autoBind from 'auto-bind';

class Observer {
  constructor({ isOnce = false, rootMargin = '0px 0px 0px 0px' }) {
    this.isOnce = isOnce;
    this.rootMargin = rootMargin;

    autoBind(this);

    if ('IntersectionObserver' in window) {
      this.createObserver();
    } else {
      this.animateIn();
    }
  }

  createObserver() {
    this.observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateIn(entry.target);

            if (this.isOnce) {
              this.observer.unobserve(entry.target);
            }
          } else {
            this.animateOut(entry.target);
          }
        });
      },
      {
        rootMargin: this.rootMargin,
      }
    );
  }

  animateIn() {}

  animateOut() {}
}

export default Observer;
